import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
  GET_BILL_AZURE, GET_BILL_AZURE_SUCCESS, GET_BILL_AZURE_ERROR
} from './constant';

import { getAzureBillApi } from './api';

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureBillList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const response = yield call(getAzureBillApi, params, provider);
    const data = response?.data || response;
    yield put({ type: GET_BILL_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_BILL_AZURE_ERROR, error });
  }
}


/**
 * Get Login Saga
 */
export function* manageAzureBillSaga() {
  yield takeLatest(GET_BILL_AZURE, getAzureBillList);

}
